import { userService } from "@/app/api/user";

export interface InterviewAudioPlaybackUrl {
  playbackUrl: string;
  expiresAt: string;
}

/**
 * AS-1830: exchange a stored s3:// audio key for a short-lived presigned
 * HTTPS URL the recruiter detail panel can drop into an `<audio>` element.
 * The screener API validates the key path against the session id, so a
 * stolen recruiter JWT can't read another candidate's audio.
 */
export const getInterviewAudioPlaybackUrl = async (
  sessionId: string,
  audioKey: string,
): Promise<InterviewAudioPlaybackUrl> => {
  const response =
    await userService.axiosWithUserAuth.post<InterviewAudioPlaybackUrl>(
      `/interview/${sessionId}/audio/playback-url`,
      { audioKey },
    );
  return {
    playbackUrl: response.data.playbackUrl,
    expiresAt: response.data.expiresAt,
  };
};
